const baseUrl = process.env.VUE_APP_BASE_URL;
const apiUrl = process.env.VUE_APP_API_URL;

const environment = {
    apiUrl: `${apiUrl}`,
    baseUrl: `${baseUrl}`,
    isDevelopmentMode: process.env.NODE_ENV == 'development',
    reportServiceUrl: `${apiUrl}/ReportViewer`,
};

export default environment;

console.log("environment:", environment);
